module.exports = __webpack_public_path__ + "assets/img/20.f2929227.png";